module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_join", [["div",{"class":"left-back join-left-back-img bg-color-3"}],["div",{"class":"right-back join-right-back-img bg-color-3"}],["div",{"class":"join-wrapper"},[["div",{"class":"join-back join-left-back-img"}],["div",{"class":"join-bg-shader","id":"container"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/join.tpl
// module id = 1177
// module chunks = 4